import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Mail, Sparkles } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
export function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const normalizedEmail = email.toLowerCase().trim();
    
    if (!normalizedEmail || !normalizedEmail.includes('@')) {
      toast.error('Por favor, insira um email válido');
      return;
    }
    
    setIsLoading(true);
    try {
      // Use secure RPC function instead of direct table access
      const { data, error } = await supabase.rpc('subscribe_to_newsletter', {
        subscriber_email: normalizedEmail
      });

      if (error) throw error;

      // Cast the response to the expected type
      const result = data as { success: boolean; action?: string; error?: string; message?: string };

      if (result.success) {
        if (result.action === 'reactivated') {
          toast.success('Bem-vindo de volta! Inscrição reativada com sucesso! 🎉');
        } else {
          toast.success('Inscrição realizada com sucesso! 🎉');
        }
        setEmail('');
      } else {
        if (result.error === 'already_subscribed') {
          toast.error('Este email já está cadastrado!');
        } else if (result.error === 'invalid_email') {
          toast.error('Por favor, insira um email válido');
        } else {
          toast.error('Erro ao cadastrar. Tente novamente.');
        }
      }
    } catch (error) {
      console.error('Erro ao cadastrar email:', error);
      toast.error('Erro ao cadastrar. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };
  return <section className="bg-gradient-to-br from-kopf-primary to-kopf-accent py-10 sm:py-16 px-4">
      <div className="container mx-auto max-w-2xl text-center">
        <div className="flex justify-center mb-4">
          <div className="bg-kopf-white/20 p-3 rounded-full">
            <Sparkles className="w-6 h-6 sm:w-8 sm:h-8 text-kopf-white" />
          </div>
        </div>
        
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-kopf-white mb-4">
          Receba Insights Semanais
        </h2>
        <p className="text-kopf-white/90 text-base sm:text-lg mb-6 sm:mb-8">Cadastre-se para receber artigos sobre saúde mental e bem-estar direto no seu email</p>

        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
          <div className="flex-1 relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-kopf-text/40" />
            <Input type="email" placeholder="seu@email.com" value={email} onChange={e => setEmail(e.target.value)} className="pl-10 bg-kopf-white text-kopf-text border-0 h-12" disabled={isLoading} />
          </div>
          <Button type="submit" disabled={isLoading} className="bg-kopf-white text-kopf-primary hover:bg-kopf-white/90 font-semibold h-12 px-8">
            {isLoading ? 'Cadastrando...' : 'Inscrever-se'}
          </Button>
        </form>

        <p className="text-kopf-white/70 text-sm mt-4">
          Sem spam. Cancele quando quiser.
        </p>
      </div>
    </section>;
}